import { render } from "./NewsDetail.vue?vue&type=template&id=68be224e&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=68be224e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68be224e"

export default script